import { ReactElement, useContext } from "react";
import { DelayContext } from "../../../context/delayContext";
import { IDelayBase, IDelayMeltShop } from "../../../types";
import InterruptionTable from "../interruptionTable";

interface IGeneralPanelProps {
  delays: IDelayMeltShop[];
  selected: IDelayMeltShop | null;
  setSelected: (delay: IDelayBase) => void;
}

const DelayPanel = ({ delays, selected, setSelected }: IGeneralPanelProps): ReactElement => {
  const delayContext = useContext(DelayContext);

  return delayContext && delayContext.consolidated
    ? <InterruptionTable data={delays} selected={selected} setSelected={setSelected} categoryProcessed={delayContext.consolidated} parentSize={{ width: 0, height: 500 }}/>
    : <div/>;
};

export default DelayPanel;
